module.exports = __webpack_public_path__ + "img/ml_icon.88b78e3c.svg";